import React, { useState } from "react";
import { array } from "prop-types";

import Checkbox from "../../atoms/Checkbox";
import TextField from "../../atoms/TextField";
import Button from "../../atoms/Button";
import DesktopLogo from "../../atoms/DesktopLogo";

import "./newsletter.m.css";

const Newsletter = ({ list }) => {
  const [selectedList, setSelectedList] = useState([]);
  const [email, setEmail] = useState("");

  const onChange = (e, id) => {
    if (e.target.checked) {
      // Add an element
      const tempList = [...selectedList];

      tempList.push(id);
      setSelectedList(tempList);
    } else {
      // Remove an element from the selected list
      setSelectedList(selectedList.filter(value => value !== id));
    }
  };

  const textChange = e => setEmail(e.target.value);

  return (
    <div styleName="container">
      <div>
        <div styleName="signup">Sign up for our Newsletters</div>
        <div styleName="signup-free">
          Sign up for our free newsletters and get award winning content delivered direct to your inbox.
        </div>

        <div styleName="section-wrapper">
          {list &&
            list.map((item, index) => (
              <div key={index} styleName="section">
                <Checkbox
                  text={item.name}
                  isChecked={selectedList.includes(item.id)}
                  onChange={e => onChange(e, item.id)}
                />
                <div styleName="preview">Preview</div>
              </div>
            ))}
        </div>

        <div styleName="form-fields">
          <TextField value={email} inputType="type2" placeholder="who@areyou.com" onChange={textChange} />
          <Button content="সাবস্ক্রাইব" buttonType="type2" />
        </div>

        <div styleName="terms-privacy">
          By registering, you agree to the Prothom Alo’s <a>Terms of Use</a> and <a>Privacy Policy</a>
        </div>
      </div>

      <DesktopLogo />
    </div>
  );
};

Newsletter.propTypes = {
  list: array
};

export default Newsletter;
